import { IAutomationAppComponent } from "../../types";
import { schema } from "./types";
import { OverviewPanel,OperatorPanel } from '.';
import { BsStopwatch } from "react-icons/bs";

export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: BsStopwatch,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    createConfig:     {
        group: 'Devices',
        name: "Operation hours counter",
        description: "Operation hours counter",
        panel: OverviewPanel,
        defaultState: {  value: 15.3 }
    },
}